export default __webpack_public_path__ + "static/media/37.c7f9be0a.jpg";